import styled from "styled-components";

export const ModalWrapper = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 500;
`;

export const ModalContents = styled.div`
  z-index: 32;
  position: fixed;
  top: 50%;
  left: 50%;
  width: calc(100% - 32px);
  transform: translate(-50%, -50%);
`;

export const Background = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.64);
`;
